import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=23c3ce36&scoped=true"
import script from "./FilesModal.vue?vue&type=script&lang=js"
export * from "./FilesModal.vue?vue&type=script&lang=js"
import style0 from "./FilesModal.vue?vue&type=style&index=0&id=23c3ce36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3ce36",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/FilesModal.vue
// module id = 1966
// module chunks = 31